import {
  AuthService,
  IdentityAccessValueFactory,
  PolicyService,
  PolicyType,
  provideIdentityAccessPermissions,
} from '@finverity/identity-access';

import { FunderInstrumentApprovalMakerPermissions } from './funder-instrument-approval-maker-permissions';

const FUNDER_INSTRUMENT_APPROVAL_MAKER_IDENTITY_ACCESS_FACTORY: IdentityAccessValueFactory<
  FunderInstrumentApprovalMakerPermissions
> = (authService: AuthService, policyService: PolicyService) => {
  return {
    [FunderInstrumentApprovalMakerPermissions.ViewInstruments]: true, // TODO: replace for normal Policies: policyService.hasPolicies('view_documents'),
    [FunderInstrumentApprovalMakerPermissions.ViewInstrumentDetails]: policyService.hasPolicies(
      PolicyType.VIEW_INSTRUMENT_DETAILS
    ),
    [FunderInstrumentApprovalMakerPermissions.ViewInstrumentAttachments]: policyService.hasPolicies(
      PolicyType.VIEW_DOCUMENTS
    ),
    [FunderInstrumentApprovalMakerPermissions.ReviewInstruments]: policyService.hasPolicies([
      PolicyType.CONFIRM_INSTRUMENTS_FUNDER_MAKER,
      PolicyType.CONFIRM_INSTRUMENTS_FUNDER_APPROVAL_MAKER,
    ]),
    [FunderInstrumentApprovalMakerPermissions.RejectInstruments]: policyService.hasPolicies(
      PolicyType.REJECT_INSTRUMENTS_FUNDER_APPROVAL_MAKER
    ),
  };
};

export const FUNDER_INSTRUMENT_APPROVAL_MAKER_IDENTITY_ACCESS_PROVIDER = provideIdentityAccessPermissions(
  FUNDER_INSTRUMENT_APPROVAL_MAKER_IDENTITY_ACCESS_FACTORY
);
